"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillEmptyCustomerFields = fillEmptyCustomerFields;
const CUSTOMER_FIELDS = ['name', 'address', 'phone'];
function fillEmptyCustomerFields(current, lead) {
    const filled = {};
    for (const field of CUSTOMER_FIELDS) {
        const leadValue = lead[field]?.trim();
        if (leadValue && !current[field]?.trim())
            filled[field] = leadValue;
    }
    return filled;
}
